/* import __COLOCATED_TEMPLATE__ from './delinquent-account-modal.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { closeModal } from 'sh-www/utils/modal-controls';
import { dropTask } from 'ember-concurrency';

class DelinquentAccountModal extends Component {
  onComplete = this.args.model.onClose;

  @action
  dismiss() {
    closeModal(this);
  }
}

export default DelinquentAccountModal;
